<div [ngClass]="editMode ? 'filter-banner-outer-wrapper-active' : 'filter-banner-outer-wrapper'">
  <div id="filter-banner-wrapper">
    <div id="upper-section">
      <span id="upper-section-left">
        <span id="breadcrumb-and-page">
          <div id="page-label">{{pageLabel}}</div>
          <div id="breadcrumb-wrapper"
               style="display: flex; flex-direction: row; margin-right: 15px">
            <i *ngIf="isDrillDown"
               class="fa fa-arrow-left {{editMode? 'back-button-disabled':'back-button'}}"
               id="back-button" alt="Back Symbol" (click)="navigateBack()">
            </i>
            <div id="breadcrumb" (click)="setTab()">
              <div id="node-path-loading" *ngIf="!breadcrumb.length">Loading</div>
              <span id="breadcrumb-text" [matTooltip]="breadcrumb.length > maxCharsForNodePath ? breadcrumb : ''">{{breadcrumb}}</span>
            </div>
            <i id="breadcrumb-caret" class="fa fa-caret-down"></i>
            <app-custom-group-select [customGroups]="customGroups"
                                     [currentSelectedGroup]="selectedGroup"
                                     (selectionChange)="selectGroup($event)">
            </app-custom-group-select>
          </div>
        </span>
      </span>
      <div *ngIf="editMode" id="apply-section">
        <span style="white-space: nowrap">
          <button id="btn-clear" (click)="clearSelections()">Clear All Selections</button>
          <button (click)="restoreDefault()" [ngClass]="theDefaultGroup ? 'btn-restore' : 'btn-dont-restore'"
                  id="btn-restore">
            Restore Default</button>
          <button id="btn-save-grouping" (click)="openSaveDialog()">Save Grouping and Filters</button>
        </span>
        <button (click)="cancel()" id="btn-cancel">Cancel</button>
        <button (click)="apply()" [ngClass]="unsavedData ? 'btn-apply' : 'disabled-apply'">
          Apply
        </button>
      </div>
      <app-export-button *ngIf="!editMode" (afterPdfExport)="exportToPdf($event)"></app-export-button>
    </div>
    <div id="tab-section">
      <span *ngFor="let tab of updatedBannerTabs" [ngClass]="tab.tab === selectedTab ? 'tab-selected' :
        editMode || tab.available ? 'tab' : 'unavailable-tab'" class="general-tab" (click)="setTab(tab)"
            [matTooltip]="'This filter is not applicable on this Metric'"
            [matTooltipDisabled]="editMode || tab.available">
        <div class="tab-title">{{tab.title}}</div>
        <div class="tab-label">{{tab.label}}</div>
      </span>
    </div>
    <div [ngSwitch]="selectedTab" id="edit-wrapper" *ngIf="editMode">
      <div id="edit-window">
        <app-viz-date-range-picker *ngSwitchCase="FilterBannerTab.DATE" (dateChange)="onDateChange($event)"
                                   [rangeMode]="true" typeMode="month"
                                   [date]="selectedDateForRangeCalendar" [filterBannerFlag]="true">
        </app-viz-date-range-picker>
        <app-search-provider *ngSwitchCase="FilterBannerTab.PROVIDER" [ontologyListData]="ontologyListData"
                             [onProvidersChanged]="onFiltersChanged" [filterTab]="providerTab"
                             [selectedGroup]="selectedGroup" [customGroups]="customGroups"
                             [parentApply]="applyWithoutSavingGroup" [parent]="this">
        </app-search-provider>
        <app-search-location *ngSwitchCase="FilterBannerTab.LOCATION" [locations]="locations"
                             [onLocationChanged]="onFiltersChanged" [filterTab]="locationTab"
                             [showLoadingIndicator]="locationLoadingIndicator">
        </app-search-location>
        <app-select-payer *ngSwitchCase="FilterBannerTab.PAYER"
                          [payers]="payers"
                          [shouldPayersBeGranular]="shouldPayersBeGranular"
                          [onPayerChanged]="onFiltersChanged" [filterTab]="payerTab"
                          [showLoadingIndicator]="payerLoadingIndicator"
        ></app-select-payer>
        <app-search-billing-areas *ngSwitchCase="FilterBannerTab.BILLING" [billingAreas]="billingAreas"
                                  [onBillingAreaChanged]="onFiltersChanged" [filterTab]="billingTab"
                                  [showLoadingIndicator]="billingLoadingIndicator">
        </app-search-billing-areas>
        <app-search-lag-key *ngSwitchCase="FilterBannerTab.LAG" [lagPeriods]="lagPeriods" [filterTab]="lagTab"
                            [onPeriodChanged]="onFiltersChanged">
        </app-search-lag-key>
        <app-invoice *ngSwitchCase="FilterBannerTab.INVOICE_STATUS" [invoiceStatuses]="invoiceStatusTypes"
                     [onStatusChanged]="onFiltersChanged" [filterTab]="invoiceTab">
        </app-invoice>
        <app-visit-type *ngSwitchCase="FilterBannerTab.VISIT_TYPE" [visitTypes]="visitTypes" [filterTab]="visitTab"
                        [onVisitTypeChanged]="onFiltersChanged">
        </app-visit-type>
        <app-multi-search-location *ngSwitchCase="FilterBannerTab.MULTI_LOCATION"
        [locations]="locations"
        [onLocationChanged]="onFiltersChanged" [filterTab]="locationTab"
        [showLoadingIndicator]="locationLoadingIndicator"></app-multi-search-location>
      </div>
    </div>
  </div>
</div>
<div id="pdf-content">
  <app-export-pdf-dialog #pdfContent></app-export-pdf-dialog>
</div>
